"use client";
import { PRIZES } from "@/ui/data";
import { FC } from "react";
import PrizeItem from "@/components/common/PrizeItem";

type Props = {
	strapiData: any;
};

const Prize: FC<Props> = ({ strapiData }) => {
	const prizeItems = strapiData?.prizeData?.data;
	const prizeList = Array.isArray(prizeItems)
		? prizeItems
		: prizeItems
			? [prizeItems]
			: [];
	const prizes = prizeList.map((el: any) => el.attributes);
	const combinedPrizes = PRIZES.map((el, index) => ({
		...el,
		title: prizes[index]?.title ?? el.title,
		text: prizes[index]?.text ?? el.text,
		white: prizes[index]?.white ?? el.white,
		img: prizes[index]?.img ?? el.img,
	}));
	return (
		<div className='w-full bg-prizeScreenGradient pt-[149px] max-desktop:pt-[97px] max-desktop:px-[32px] max-tablet:py-[30px] max-tablet:pt-[106px] px-[81px] max-tablet:px-[58px] flex max-tablet:flex-col gap-[22px] max-desktop:gap-[14px] max-tablet:gap-[19px] mt-[-1px]'>
			{combinedPrizes.map((el, index) => (
				<PrizeItem
					key={index}
					img={el.img}
					title={el.title}
					text={el.text}
					white={el.white}
				/>
			))}
		</div>
	);
};

export default Prize;
